import React from "react";
import Script from "next/script";

import SSRProvider from "react-bootstrap/SSRProvider";
import AuthProvider from "contexts/AuthProvider";
import App from "components/App";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";
//Fixes a bug with server side rendering icons
config.autoAddCss = false; /* eslint-disable import/first */
import "styles/main.css";
import "styles/index.scss";

function MyApp({ Component, pageProps, router }) {
	return (
		<SSRProvider>
			<AuthProvider router={router}>
				<App Component={Component} pageProps={pageProps} router={router} />
				
				{/* CRITICAL FIX: Move third-party scripts here with next/script to prevent hydration issues */}
				
				<Script 
					src="/static/default-consent.js" 
					strategy="beforeInteractive"
				/>
				
				<Script 
					src={`https://cmp.osano.com/${process.env.OSANO_GDPR || 'default'}/osano.js`} 
					strategy="afterInteractive"
					onError={(e) => {
						console.warn('Failed to load Osano GDPR script:', e);
					}}
				/>
				
				<Script
					data-jsd-embedded
					data-key="4c9904e7-641a-49ef-ab02-71acf205401b"
					data-base-url="https://jsd-widget.atlassian.com"
					src="https://jsd-widget.atlassian.com/assets/embed.js"
					data-lazyload="yes"
					strategy="lazyOnload"
					onError={(e) => {
						console.warn('Failed to load Jira script:', e);
					}}
				/>
				
				<Script
					type="text/javascript"
					id="hs-script-loader"
					src="//js.hs-scripts.com/2735001.js"
					strategy="lazyOnload"
					onError={(e) => {
						console.warn('Failed to load HubSpot script:', e);
					}}
				/>
			</AuthProvider>
		</SSRProvider>
	);
}

export default MyApp;
